<template>
  <div class="page flex-col">
    <div class="box_n flex-col">
      <div class="group_1 flex-col">
           <headerMask/>
      </div>
    </div>

    <div class="box_4 flex-col">
      <div class="section_2 flex-row justify-between">
        <div class="box_5 flex-col"></div>
        <span class="text_8">以动健康</span>
        <div class="box_6 flex-col"></div>
      </div>
      <span class="text_9">以运动处方科技助力健康</span>
      <div class="text-wrapper_1">
        <span class="text_10">公司简介：</span>
        <span class="paragraph_1">
          新加坡上市公司保德集团投资Pre-A轮的智慧运动康复企业
          <br />
          <br />
        </span>
        <span class="text_11">我们的定位：</span>
        <span class="text_12">智慧化运动处方解决方案及数字疗法提供商–</span>
        <span class="paragraph_2">
          &nbsp;30余家康复机构，近2000名治疗师，20000余患者的选择
          <br />
          <br />
          我们的理想
        </span>
        <span class="paragraph_3">
          ：让中国每个人都能享受到高质量的运动康复服务
          <br />
          <br />
        </span>
        <span class="text_13">主要特色：国内首个商用运动处方数据库</span>
        <span class="paragraph_4">
          ，通过临床验证的康复计划及AI辅助诊疗，带来更优质康复效果
          <br />
        </span>
      </div>
    </div>
    <div class="box_7 flex-col">
      <div class="box_8 flex-row">
        <div class="group_2 flex-col"></div>
        <div class="group_3 flex-col"></div>
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-col"></div>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_14">团队介绍</span>
      </div>
      <div class="box_9 flex-row justify-between">
        <div class="block_2 flex-row">
          <div class="section_3 flex-col"></div>
          <div class="section_4 flex-col justify-between">
            <div class="text-group_1 flex-col justify-between">
              <span class="text_15">郭威</span>
              <span class="text_16">创始人/总经理</span>
            </div>
            <div class="block_3 flex-col"></div>
          </div>
          <div class="text-wrapper_2 flex-col">
            <span class="text_17">手机：13220190868</span>
            <span class="text_18">邮箱：info&#64;ktangtang.com</span>
            <span class="text_19">学历：硕士</span>
            <span class="text_20">毕业学校：纽约大学</span>
            <span class="text_21">
            
            </span>
          </div>
        </div>
        <div class="block_4 flex-row">
          <div class="image-wrapper_1 flex-col">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG0fc5423660fb17df316d27b72439dd90.png'"
            />
          </div>
          <div class="box_10 flex-col justify-between">
            <div class="block_5 flex-row justify-between">
              <div class="text-wrapper_3 flex-col"><span class="text_22">马兖</span></div>
              <span class="text_23">特聘专家</span>
            </div>
            <div class="block_6 flex-row justify-between">
              <div class="block_7 flex-col justify-between">
                <div class="group_6 flex-col"></div>
                <div class="group_7 flex-col"></div>
                <div class="group_8 flex-col"></div>
              </div>
              <div class="text-group_2 flex-col justify-between">
                <span class="text_24">北京体育大学博士研究生</span>
                <span class="text_25">拥有五年以上网络应用项目研发经验</span>
                <span class="text_26">2022北京冬奥会赛前心理科技服务课题负责人</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid_1 flex-row">
        <div class="group_9 flex-row">
          <div class="image-wrapper_2 flex-col">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG714008a70806d210b5a857cc5658d16f.png'"
            />
          </div>
          <div class="section_5 flex-col justify-between">
            <div class="box_11 flex-row justify-between">
              <div class="text-wrapper_4 flex-col"><span class="text_27">聂学真</span></div>
              <span class="paragraph_5">
                联合创始人&nbsp;供应链负责人
                <br />
              </span>
            </div>
            <div class="box_12 flex-row justify-between">
              <div class="block_8 flex-col">
                <div class="group_10 flex-col"></div>
                <div class="group_11 flex-col"></div>
                <div class="group_12 flex-col"></div>
              </div>
              <div class="text-group_3 flex-col justify-between">
                <span class="text_28">负责公司物联网硬件产品供应链管理。</span>
                <span class="text_29">
                  知名连续创业者，先后创立了深圳超级云计算，深圳无线新科技，酷玩部落等耳熟能详得品牌
                </span>
                <span class="text_30">在深圳创立的手机代工厂年流水超过10亿，获得过深创投等知名机构的融资。</span>
              </div>
            </div>
          </div>
        </div>
        <div class="group_13 flex-row">
          <div class="group_14 flex-col">
            <div class="box_13 flex-row">
              <div class="box_14 flex-col"></div>
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGcedc9cad2b62f890f3613a4d994e8643.png'"
              />
            </div>
          </div>
          <div class="group_15 flex-col">
            <div class="group_16 flex-row justify-between">
              <div class="text-wrapper_5 flex-col"><span class="text_31">Dr.&nbsp;Marilyn&nbsp;Moffat</span></div>
              <span class="text_32">首席顾问</span>
            </div>
            <div class="group_17 flex-row justify-between">
              <div class="box_15 flex-col"></div>
              <span class="text_33">纽约大学终身教授</span>
            </div>
            <div class="group_18 flex-row justify-between">
              <div class="group_19 flex-col"></div>
              <span class="text_34">国际物理治疗师联盟新卸任主席</span>
            </div>
            <div class="group_20 flex-row justify-between">
              <div class="section_6 flex-col"></div>
              <span class="text_35">美国物理治疗师联盟前主席,&nbsp;运动处方届元老</span>
            </div>
            <div class="group_21 flex-row justify-between">
              <div class="group_22 flex-col"></div>
              <span class="text_36">负责公司医学技术及相关数据库研发咨询，培训，高新技术转让</span>
            </div>
          </div>
        </div>
        <div class="group_23 flex-row">
          <div class="box_16 flex-col">
            <div class="image-wrapper_3 flex-col">
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG9645a6a9b6025270fbb9e8c4809e83c4.png'"
              />
            </div>
          </div>
          <div class="box_17 flex-col">
            <div class="block_9 flex-row justify-between">
              <div class="text-wrapper_6 flex-col"><span class="text_37">郭建军</span></div>
              <span class="text_38">首席专家</span>
            </div>
            <div class="block_10 flex-row justify-between">
              <div class="section_7 flex-col"></div>
              <span class="text_39">负责公司医疗技术收集和支持，产品市场推广</span>
            </div>
            <div class="block_11 flex-row justify-between">
              <div class="box_18 flex-col"></div>
              <span class="text_40">国家医体整合联盟秘书长，总策划人和执行人</span>
            </div>
            <div class="block_12 flex-row justify-between">
              <div class="group_24 flex-col"></div>
              <span class="text_41">中华预防医学会糖尿病预防与控制专业委员会委员</span>
            </div>
            <div class="block_13 flex-row justify-between">
              <div class="block_14 flex-col"></div>
              <span class="text_42">首都体育学院体医融合中心主任、前国家体育总局体医融合促进与创新研究中心主任</span>
            </div>
            <div class="block_15 flex-row justify-between">
              <div class="box_19 flex-col"></div>
              <span class="text_43">中国康复医学会心血管、呼吸康复专业委员会常委</span>
            </div>
            <div class="block_16 flex-row justify-between">
              <div class="section_8 flex-col"></div>
              <span class="text_44">中国健康促进与教育协会运动与康复分会副主任委员</span>
            </div>
          </div>
        </div>
        <div class="group_25 flex-row">
          <div class="section_9 flex-col">
            <div class="box_20 flex-row">
              <div class="section_10 flex-col"></div>
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGe19403e86ef04d13e36aa9b8aa36b759.png'"
              />
            </div>
          </div>
          <div class="section_11 flex-col">
            <div class="box_21 flex-row justify-between">
              <div class="text-wrapper_7 flex-col"><span class="text_45">Dr.Karen&nbsp;Kemmis</span></div>
              <span class="text_46">医疗顾问</span>
            </div>
            <div class="box_22 flex-row justify-between">
              <div class="box_23 flex-col"></div>
              <span class="text_47">世界上历史最悠久的糖尿病研究中心</span>
            </div>
            <div class="box_24 flex-row justify-between">
              <div class="group_26 flex-col"></div>
              <span class="text_48">哈佛大学Joslin糖尿病研究中心的主管治疗师</span>
            </div>
            <div class="box_25 flex-row justify-between">
              <div class="group_27 flex-col"></div>
              <span class="text_49">美国糖尿病教育协会现主席</span>
            </div>
            <div class="box_26 flex-row justify-between">
              <div class="box_27 flex-col"></div>
              <span class="text_50">产品逻辑设计顾问</span>
            </div>
          </div>
        </div>
        <div class="group_281 flex-row">
          <div class="box_28 flex-col">
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG51015a74926b954d137d4d0938e846e2.png'"
              />
            </div>
          </div>
          <div class="box_29 flex-col">
            <div class="group_29 flex-row justify-between">
              <div class="text-wrapper_8 flex-col"><span class="text_51">贾树利</span></div>
              <span class="text_52">董事&nbsp;销售负责人</span>
            </div>
            <div class="group_30 flex-row justify-between">
              <div class="section_12 flex-col"></div>
              <span class="text_53">2022年度国内前三康复设备销售代理公司董事长</span>
            </div>
            <div class="group_31 flex-row justify-between">
              <div class="block_17 flex-col"></div>
              <span class="text_54">
                公司拥有国内前三大的康复设备销售团队，公司从代理国外康复设备开始做起，后被新加坡白石资本和新加坡保德集团投资。
              </span>
            </div>
            <div class="group_32 flex-row justify-between">
              <div class="box_30 flex-col"></div>
              <span class="text_55">冬奥会的运动康复设备都由北京普康供货。</span>
            </div>
          </div>
        </div>
        <div class="group_33 flex-row">
          <div class="image-wrapper_5 flex-col">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGf3a3a2e6f295df3289eeea2b3ac9936f.png'"
            />
          </div>
          <div class="box_31 flex-col">
            <div class="group_34 flex-row justify-between">
              <div class="text-wrapper_9 flex-col"><span class="text_56">何铁强</span></div>
              <span class="text_57">产业顾问</span>
            </div>
            <div class="group_35 flex-row justify-between">
              <div class="block_18 flex-col"></div>
              <span class="text_58">中国人寿健康投资部门副总裁</span>
            </div>
            <div class="group_36 flex-row justify-between">
              <div class="block_19 flex-col"></div>
              <span class="text_59">原国家卫生健康计划委员会重大疾病处处长</span>
            </div>
            <div class="group_37 flex-row justify-between">
              <div class="group_38 flex-col"></div>
              <span class="text_60">公司商业模式咨询和渠道建设</span>
            </div>
            <div class="group_39 flex-row justify-between">
              <div class="group_40 flex-col"></div>
              <span class="text_61">北京肿瘤医院原医务处处长</span>
            </div>
          </div>
        </div>
      </div>
      <img
        class="image_9"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd6b436eef2b483e3247bf93be1e553d1.png'"
      />
      <div class="text-wrapper_10 flex-row">
        <span class="paragraph_6">
          负责公司商业方向，产品功能制定，管理组建公司团队，融资
          <br />
          创立过美国超新星留学文书工作室和康糖医疗糖尿病康复公司
          <br />
        </span>
        <span class="text_62">
          美国注册物理治疗师，中国队游泳队前队医，北京朝阳区凤凰计划海归人才，北京中关村雏鹰人才北京卫视养生堂，健康北京，央视健康之路，央广等栏目的慢病运动指导专家
        </span>
      </div>
    </div>
    <div class="box_32 flex-col">
      <div class="box_33 flex-row">
        <div class="group_41 flex-col"></div>
        <div class="group_42 flex-col"></div>
        <div class="group_43 flex-col"></div>
        <div class="group_44 flex-col"></div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_7"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_63">合作医院</span>
      </div>
      <div class="box_34 flex-row">
        <div class="image-text_w1 flex-col justify-between">
          <div class="image-wrapper_w6 flex-col">
            <img
              class="image_w12"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGe66e8a5c811d7f3b999b4604ebe90728.png'"
            />
          </div>
          <span class="text-group_w4">南方医科大</span>
        </div>
        <div class="group_45 flex-col justify-between">
          <div class="group_46 flex-col">
            <div class="image-wrapper_6 flex-col">
              <img
                class="image_11"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG9a26dcfdb0fc99a0be30b9d297bf9388.png'"
              />
            </div>
          </div>
          <span class="paragraph_7">
            北京医院
            <br />
            （国家老年医学中心）
          </span>
        </div>
        <div class="image-text_2 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGa73e19dca22040c0e99df429579a5031.png'"
          />
          <span class="text-group_5">北京大学人民医院</span>
        </div>
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_13"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG54f9e3e5ad494c76b1e2601fb24819a6.png'"
          />
          <span class="text-group_6">
            首都医科大学附属
            <br />
            北京安定医院
          </span>
        </div>
        <div class="image-text_4 flex-col justify-between">
          <img
            class="image_14"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGf9256286f04e49c1617057ceb12b7ff6.png'"
          />
          <span class="text-group_7">
            首都医科大学
            <br />
            北京朝阳医院
          </span>
        </div>
  
        <div class="image-text_6 flex-col justify-between">
          <img
            class="image_16"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG21e9b05fe3e541720bb411aea9eaa06c.png'"
          />
          <span class="text-group_9">中日友好医院</span>
        </div>

      </div>
      <div class="box_35 flex-row">
        <div class="box_36 flex-col"></div>
        <div class="box_37 flex-col"></div>
        <div class="box_38 flex-col"></div>
        <div class="box_39 flex-col"></div>
        <img
          class="thumbnail_8"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_64">合作公司</span>
      </div>
      <div class="image-wrapper_7 flex-row justify-between">
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG70c217648c0e5f024e912dad8c2bba28.png'"
        />
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGa027738f54cb246027fc14d5a3e7e076.png'"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGc726f48a01f4b2e89a5011c71dbe7c36.png'"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG3be3c9e39172acbfd1517a447540b5fe.png'"
        />
        <img
          class="image_22"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG51351baf733a2b77435be34c233dbfef.png'"
        />
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG2208d344c7584e28d53d9a2b6eab485f.png'"
        />
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGa5d7c9c3dc560138a0c8489d1e035347.png'"
        />
      </div>
      <div class="box_40 flex-row">
        <div class="box_41 flex-col"></div>
        <div class="box_42 flex-col"></div>
        <div class="box_43 flex-col"></div>
        <div class="box_44 flex-col"></div>
        <img
          class="thumbnail_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_65">公司项目覆盖情况</span>
      </div>
      <div class="image-wrapper_8 flex-row">
        <img
          class="image_25"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png'"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG81b2d6d9eb5e06b85cd8af3f28f98fb9.png'"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG5159410fc10ca594826b53eb6bbc51dc.png'"
        />
        <img
          class="image_28"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGc0189645430acca8d357caeabdb4f886.png'"
        />
        <img
          class="image_29"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGb19b3156911d708d7021a7e799ab7148.png'"
        />
        <img
          class="image_30"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGe40066d95348fc239dd2466cc6f106e8.png'"
        />
        <img
          class="image_31"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG251a106a920e59378ceee9ded7ea2c9d.png'"
        />
        <img
          class="image_32"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png'"
        />
      </div>
      <div class="text-wrapper_11 flex-row">
        <span class="text_66">深圳招商健康</span>
        <span class="text_67">北京中日友好医院</span>
        <span class="text_68">北京老年医院</span>
        <span class="paragraph_8">
          北京大兴清源路街道
          <br />
          养老社区SMIC
        </span>
        <span class="text_69">北京聚陆医疗</span>
        <span class="paragraph_9">
          北京顺义“妙健康”金茂怡生园
          <br />
          加拿大健康管理中心
        </span>
      </div>
      <div class="box_45 flex-row">
        <div class="section_13 flex-col"></div>
        <div class="section_14 flex-col"></div>
        <div class="section_15 flex-col"></div>
        <div class="section_16 flex-col"></div>
        <img
          class="thumbnail_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_70">公司项目参赛奖项</span>
      </div>
      <div class="box_46 flex-row">
        <img
          class="image_33"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG01df46cc169a35ea5dca13ba19e98b66.png'"
        />
        <img
          class="image_34"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG381eb50fa128c160ccf6417479d3cef7.png'"
        />
        <img
          class="image_35"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG32d2cf1ce35bbc763956c678bf5612fb.png'"
        />
        <img
          class="image_36"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGf0b1130b33efeaafe5a4b5a8204fea88.png'"
        />
        <div class="image-wrapper_9 flex-col">
          <img
            class="image_37"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNGbfd74bd93aba47fa6e777d2ce6d9b3d6.png'"
          />
        </div>
      </div>
      <div class="text-wrapper_12 flex-col">
        <span class="text_71">联系方式</span>
        <span class="text_72">contact&nbsp;information</span>
        <span class="text_73">132-2019-0868</span>
        <span class="text_74">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        <span class="text_75">info&#64;ktangtang.com</span>
        <span class="text_76">https://ktangtang.com</span>
      </div>
    </div>
    <div class="box_47 flex-col">
      <div class="image-wrapper_10 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG7096386e6573f0a8cef83156f22c8075.png'"
        />
        <img
          class="image_38"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/about/FigmaDDSSlicePNG17efb882da7b155836e0d686fee9a84e.png'"
        />
      </div>
<footerMask/>
    </div>
  </div>
</template>
<script>
import headerMask from "../../components/header";
import footerMask from "../../components/footer";
export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight < 1200){
      this.$router.push({path: '/about_us'})
    }
  
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />